/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpVaultConfigInput {
  /**
  * The name of the bucket
  */
  'bucketName'?: string;
  /**
  * Resource ID of the Cloud KMS key used for encryption. Omitted if the key is managed by Eon. 
  */
  'encryptionKey'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "bucketName",
      "baseName": "bucketName",
      "type": "string",
      "format": ""
    },
    {
      "name": "encryptionKey",
      "baseName": "encryptionKey",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpVaultConfigInput.attributeTypeMap;
  }

  public constructor() {
  }
}

